
import React from 'react';
import { Product } from '@/lib/supabase/products/types';
import ProductMedia from './ProductMedia';
import ProductDetails from './ProductDetails';
import ProductOrderForm from './ProductOrderForm';
import BreadcrumbNav from './BreadcrumbNav';
import { Container } from '@/components/ui/container';
import { Separator } from '@/components/ui/separator';

interface ProductPageContainerProps {
  product: Product;
  shopId: string | null;
  organizationId: string | null;
}

const ProductPageContainer = ({ product, shopId, organizationId }: ProductPageContainerProps) => {
  // Log the product for debugging
  console.log("ProductPageContainer received product:", product);
  
  // Ensure media_urls is an array even if it's null or undefined
  const mediaUrls = product.media_urls || [];
  console.log("Product media URLs:", mediaUrls);
  
  return (
    <Container className="py-8">
      <div className="mb-4">
        <BreadcrumbNav productName={product.name} />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left column: Product Images */}
        <div>
          <ProductMedia 
            images={mediaUrls} 
            productName={product.name} 
          />
        </div>
        
        {/* Right column: Product Order Form */}
        <div>
          <ProductOrderForm 
            product={product}
            shopId={shopId}
            organizationId={organizationId}
          />
        </div>
      </div>
      
      <Separator className="my-12" />
      
      {/* Product Details Section */}
      <div className="mt-8">
        <ProductDetails product={product} />
      </div>
    </Container>
  );
};

export default ProductPageContainer;
